module.exports = __webpack_public_path__ + "static/media/pigeon-pendent_720x480.4eab7aa7.jpg";